import { all } from "redux-saga/effects";
import workflowsSaga from "./sagas/workflowsSaga";
import formsSaga from "./sagas/formsSaga";
import databaseSaga from "./sagas/databaseSaga";
import offlineSaga from "./sagas/offlineSaga";

export default function* rootSaga() {
	yield all([workflowsSaga(), formsSaga(), databaseSaga(), offlineSaga()]);
}
